/*=================================================
    summary: 學生作答 填空題型 下方內容 FillInContent
             練習 寫一寫                LUSeqNo: 26         
             複習 寫作                  LUSeqNo: 27

             Practice Writing Grammar Exercises
             Review Writing Grammar Exercises

    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2022/01/13 增加 讀取 ContentText 圖片 流程
             002 Tim 2022/01/14 串接 LanguageChangeHandler 流程
             003 Tim 2022/03/14 補上 BlockedInstructor 機制
=================================================*/

// richard: 
// 這個LU 使用到的 TestSheet 有包含：1. TextArea
// 1. TextArea 需要使用 State 的變數 bind 在 value, 如此才能因為 user 改變內容而即時改變 UI (經由 State 的改變，ReRender)
// 上面兩個需求，我目前的能力只能在 Page Chagned 的時候做到

import React, { useEffect, useState, useRef, useContext } from 'react'
import cssFillInContent from './FillInContent.module.scss'

import { TestSheetModeEnum } from '../CompositionContent/CompositionContent'

import { LUCacheContext } from '../../../LearningUnit.js'

import parse from 'html-react-parser'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "FillInContent"

const IMAGE_DISPLAY_WIDTH = 700
const MAX_ANSWER_CHARACHERS = 54    // Textarea最大的數字限制
// #endregion Constant

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrBookCatID = ""
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrImagePrefix = ""
let mintAccountRole = 0
let mintClassID = -1

let mintIndex4HistoryItemToShow = -1

let mobjTestSheet = {
    "Mode": TestSheetModeEnum.New,
    "Score": -1,
    "Dirty": false,
    "AnswerList": [],
    "AssignID": -1
}

let marrContentData = []
let mintSQIndex4PreloadThumbnailImage = 0
let mintImgIndex4PreloadThumbnailImage = 0
let mintSQIndex4PreloadOriginalImage = 0
let mintImgIndex4PreloadOriginalImage = 0

let mobjDisplaySubSubSection = {
    "NameEN": "",
    "NameCN": ""
}
let marrDisplayQuestion = []
// #endregion Member Variables

function FillInContent(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [answerArray, setAnswerArray] = useState([])
    // #endregion Init State

    // #region Init Ref
    let mrefScrollArea = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true

        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }
    } // end of if (!mblnInitialized) 
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false
            mstrBookCatID = ""
            mstrLUKey4LUCachedContext = "" 
            mstrImagePrefix = ""
            mintAccountRole = 0
            mintClassID = -1

            mobjTestSheet = {
                "Mode": TestSheetModeEnum.New,
                "Score": -1,
                "Dirty": false,
                "AnswerList": [],
                "AssignID": -1
            }
            mobjDisplaySubSubSection = {
                "NameEN": "",
                "NameCN": ""
            }
            marrDisplayQuestion = []
            mobjCallParam = null
            setUpdateDataTime(0)
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function PaintedMe()
    {
        // console.log(COMP_NAME + ".PaintedMe: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PaintedMe BEGIN")

        RegisterLanguageChangeHandler()

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key

        mstrImagePrefix = window.Globals.GetResourcePrefix(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image)
        
        let enumTestSheeMode = TestSheetModeEnum.New
        if (
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime !== null)
            )
        {
            enumTestSheeMode = TestSheetModeEnum.Temp
        }
        else if (
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
            )
        {
            enumTestSheeMode = TestSheetModeEnum.History
            mintIndex4HistoryItemToShow = 0
        }
        console.log("enumTestSheeMode: ", enumTestSheeMode)
        SetTestSheetObject(enumTestSheeMode)

        // 整理 標題資訊 (SubSubSection)
        mobjDisplaySubSubSection.NameEN = props.SubSectionDef.SubSubSection[0].Name
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MajorName
        }
        else
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MinorName
        }

        InitContentDataProcessBegin()

        console.log(COMP_NAME + ".PaintedMe END")
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 按下 歷史紀錄 按鈕
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function HistoryOnTapHandler()
    {
        // console.log(COMP_NAME + ".HistoryOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".HistoryOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log("mobjLUCacheContext:", mobjLUCacheContext)
        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList,
            "AssignmentTempAns": mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]
        }
        props.CallbackRef(objCallbackData)
    } // end of HistoryOnTapHandler

    /*===========================================
    summary: 按下 暫存作答資料 按鈕
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function SaveOnTapHandler()
    {
        // console.log(COMP_NAME + ".SaveOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SaveOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".SaveOnTapHandler: mobjTestSheet: ", mobjTestSheet)
        if (mobjTestSheet.Dirty)
        {
            mobjCallParam = {
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AnswerList": mobjTestSheet.AnswerList,
                "Score": null,
                "ActionType": 1     // 給TmpResult使用； ActionType  1: 存（實際上會清除再存） 2: 清空    
            }
            UploadNewAssignmentTmpResult()
        } // end of if (mobjTestSheet.Dirty)
    } // end of SaveOnTapHandler

    /*===========================================
    summary: 按下 重新開始 or 繼續 資料 按鈕
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function TryAgainOnTapHandler()
    {
        // console.log(COMP_NAME + ".TryAgainOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".TryAgainOnTapHandler BEGIN")  
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (mrefScrollArea.current !== null)
        {
            GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 300)
        }

        let enumTestSheeMode = TestSheetModeEnum.New
        if (
            (typeof(mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]) !== 'undefined') &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] !== null) &&
            (typeof(mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime) !== 'undefined') &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime !== null)
            )
        {
            // TestSheetModeEnum.Temp
            enumTestSheeMode = TestSheetModeEnum.Temp
        }
        else
        {
            // TestSheetModeEnum.New
            enumTestSheeMode = TestSheetModeEnum.New
        }

        SetTestSheetObject(enumTestSheeMode)

        marrDisplayQuestion = FormatFQQuestionData(props.LUInfo, mobjTestSheet)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".TryAgainOnTapHandler marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of TryAgainOnTapHandler

    /*===========================================
    summary: 按下 送出作答資料 按鈕
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        // console.log(COMP_NAME + ".SubmitOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SubmitOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjCallParam = {
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "ClassID": mintClassID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AnswerList": mobjTestSheet.AnswerList
        }
        console.log(COMP_NAME + ".SubmitOnTapHandler mobjCallParam: ", mobjCallParam)
        UploadNewAssignmentResult()
    } // end of SubmitOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    /*===========================================
    summary: 作答輸入框 改變事件
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/01/21 調整 StateAnswerArray 為 2維陣列
    ===========================================*/
    function AnswerTextOnChangeHandler(e, StateAnswerArray, QuestionIndex, FillInQIndex)
    {
        console.log(COMP_NAME + ".AnswerTextOnChangeHandler: ", e)
        // console.log(COMP_NAME + ".AnswerTextOnChangeHandler e.target.value:", e.target.value)

        let arrAnswerText = JSON.parse(JSON.stringify(StateAnswerArray))
        arrAnswerText[QuestionIndex][FillInQIndex] = e.target.value

        let objAnswer = mobjTestSheet.AnswerList.find(AnswerData => 
            (
                (parseInt(AnswerData.SQIndex) === QuestionIndex) &&
                (parseInt(AnswerData.FQIndex) === FillInQIndex)
            )
        )

        if (
            (typeof(objAnswer) !== 'undefined') &&
            (objAnswer !== null)
            )
        {
            objAnswer.FQAnswer = e.target.value
            mobjTestSheet.Dirty = true
        }

        console.log(COMP_NAME + ".AnswerTextOnChangeHandler: mobjTestSheet: ", mobjTestSheet)
        console.log(COMP_NAME + ".AnswerTextOnChangeHandler: arrAnswerText: ", arrAnswerText)
        setAnswerArray(arrAnswerText)
    } // end of AnswerTextOnChangeHandler

    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        // console.log(COMP_NAME + ".LanguageOnChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".LanguageOnChangeHandler BEGIN")

        setUpdateDataTime(0)
        
        // 整理 標題資訊 (SubSubSection)
        mobjDisplaySubSubSection.NameEN = props.SubSectionDef.SubSubSection[0].Name
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MajorName
        }
        else
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MinorName
        }
        
        InitContentDataProcessBegin()
    } // end of LanguageOnChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        // console.log(COMP_NAME + ".CloseLoadingMask: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CloseLoadingMask BEGIN")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #endregion LoadingMask and Alert

    // #region Component Callback
    /*===========================================
    summary: 歷史紀錄視窗 Callback
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function HistoryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".HistoryWindowCallback: ", CallbackObj)

        let enumTestSheeMode = -1
        if (CallbackObj.Action === "HistoryWindowDetail")
        {
            console.log("HistoryWindowCallback.DetailOnTap")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)

            mintIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            enumTestSheeMode = TestSheetModeEnum.History
        }
        else if (CallbackObj.Action === "HistoryWindowLastSaved")
        {
            console.log("HistoryWindowCallback.LastSavedOnTap")

            // 點擊 HistoryWindow中的 LastSaved
            enumTestSheeMode = TestSheetModeEnum.Temp
        }

        if (mrefScrollArea.current !== null)
        {
            GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 300)
        }

        if (enumTestSheeMode !== -1)
        {
            SetTestSheetObject(enumTestSheeMode)

            marrDisplayQuestion = FormatFQQuestionData(props.LUInfo, mobjTestSheet)
            setUpdateDataTime(new Date().getTime())
            console.log(COMP_NAME + ".HistoryWindowCallback marrDisplayQuestion: ", marrDisplayQuestion)
        } // end of if (enumTestSheeMode !== -1)
    } // end of HistoryWindowCallback
    // #endregion Component Callback

    // #region Other Functions
    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        // console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler BEGIN")
        
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 設定 目前 答案物件 與 狀態
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function SetTestSheetObject(TestSheetMode)
    {
        console.log(COMP_NAME + ".SetTestSheetObject: ", TestSheetMode)

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        let arrTempAnswerList = []
        let objHistoryAnswerSheet = null
        let arrHistoryAnswerList = []

        mobjTestSheet.Mode = TestSheetMode
        mobjTestSheet.Score = -1
        mobjTestSheet.Dirty = false
        mobjTestSheet.AnswerList = []
        mobjTestSheet.AssignID = -1

        if (TestSheetMode === TestSheetModeEnum.Temp)
        {
            arrTempAnswerList = mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList
        }
        else if (TestSheetMode === TestSheetModeEnum.History)
        {
            console.log("mintIndex4HistoryItemToShow: ", mintIndex4HistoryItemToShow)
            objHistoryAnswerSheet = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList[mintIndex4HistoryItemToShow]
            arrHistoryAnswerList = objHistoryAnswerSheet.AnswerList

            mobjTestSheet.AssignID = objHistoryAnswerSheet.AssignID
            if (objHistoryAnswerSheet.Score !== null)
            {
                mobjTestSheet.Score = parseFloat(objHistoryAnswerSheet.Score)
            }
            else
            {
                mobjTestSheet.Score = null
            }
        }

        let arrTempAnswer = []
        let objTempAnswer = null

        // AnswerID: "3297"
        // LessonID: "3001"
        // SQSeqNo: "25"
        // FQSeqNo: "1"
        // FQAnswer: "1"
        // TeacherFeedbackText: "12233"

        if (TestSheetMode === TestSheetModeEnum.Temp)
        {
            arrTempAnswer = arrTempAnswerList
            console.log("Temp Temp arrTempAnswer: ", arrTempAnswer)
        }
        else if (TestSheetMode === TestSheetModeEnum.History)
        {
            arrTempAnswer = arrHistoryAnswerList
            console.log("History Temp arrTempAnswer: ", arrTempAnswer)
        }

        let intSQIndex = 0
        let intSQCount = props.LUInfo.SuperQuestion.length
        let intFQIndex = 0
        let intFQCount = 0

        let intTempIndex = 0
        let intTempCount = 0
        let strSQSeqNo = ""
        let strFQSeqNo = ""
        let blnFound = false

        let objAnswer = null

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            strSQSeqNo = props.LUInfo.SuperQuestion[intSQIndex].SQSeqNo
            intFQCount = props.LUInfo.SuperQuestion[intSQIndex].FillInQ.length

            for (intFQIndex = 0; intFQIndex < intFQCount; intFQIndex++)
            {
                strFQSeqNo = props.LUInfo.SuperQuestion[intSQIndex].FillInQ[intFQIndex].FQSeqNo
                
                if (
                    (TestSheetMode === TestSheetModeEnum.Temp) ||
                    (TestSheetMode === TestSheetModeEnum.History)
                    )
                {
                    blnFound = false
                    intTempIndex = 0
                    intTempCount = arrTempAnswer.length
                    objTempAnswer = null

                    while ((!blnFound) && (intTempIndex < intTempCount))
                    {
                        if (
                            (parseInt(arrTempAnswer[intTempIndex].SQSeqNo) === parseInt(strSQSeqNo)) &&
                            (parseInt(arrTempAnswer[intTempIndex].FQSeqNo) === parseInt(strFQSeqNo))
                            )
                        {
                            blnFound = true
                            objTempAnswer = arrTempAnswer[intTempIndex]
                        }

                        intTempIndex++
                    } // end of while intTempIndex

                    console.log("Temp or History objTempAnswer: ", objTempAnswer)
                        
                    if (
                        (typeof(objTempAnswer) !== 'undefined') &&
                        (objTempAnswer !== null)
                        )
                    {
                        objAnswer = {
                            "AnswerID": objTempAnswer.AnswerID,
                            "SQSeqNo": objTempAnswer.SQSeqNo,
                            "FQSeqNo": objTempAnswer.FQSeqNo,
                            "FQAnswer": objTempAnswer.FQAnswer,
                            "TeacherFeedbackText": objTempAnswer.TeacherFeedbackText,
                            "SQIndex": intSQIndex,
                            "FQIndex": intFQIndex
                        }
                    }
                    else
                    {
                        objAnswer = {
                            "AnswerID": null,
                            "SQSeqNo": strSQSeqNo,
                            "FQSeqNo": strFQSeqNo,
                            "FQAnswer": null,
                            "TeacherFeedbackText": null,
                            "SQIndex": intSQIndex,
                            "FQIndex": intFQIndex
                        }
                    }
                }
                else if (TestSheetMode === TestSheetModeEnum.New)
                {
                    objAnswer = {
                        "AnswerID": null,
                        "SQSeqNo": strSQSeqNo,
                        "FQSeqNo": strFQSeqNo,
                        "FQAnswer": null,
                        "TeacherFeedbackText": null,
                        "SQIndex": intSQIndex,
                        "FQIndex": intFQIndex
                    }
                }

                console.log("objAnswer: ", objAnswer)

                mobjTestSheet.AnswerList.push(objAnswer)
            } // end of for (intFQIndex = 0;
        } // end of for (intSQIndex = 0;
        console.log(COMP_NAME + ".SetTestSheetObject END mobjTestSheet: ", mobjTestSheet)
    } // end of SetTestSheetObject

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadImage)

        marrContentData = []

        let arrKeywordList = []
        let objContent = null

        // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小，且顯示題目縮圖
        // Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示

        props.LUInfo.SuperQuestion.forEach((SuperQuestion) => {
            // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SuperQuestion.ContentHTML.MajorLangKeyword : SuperQuestion.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(SuperQuestion.ContentHTML.TextWithHeight, arrKeywordList, mstrImagePrefix)

            marrContentData.push(objContent)
        }) // end of forEach SuperQuestion

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        CloseLoadingMask()

        marrDisplayQuestion = FormatFQQuestionData(props.LUInfo, mobjTestSheet)

        // 先顯示出來
        setUpdateDataTime(new Date().getTime())

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd

    // #region PreloadImage
    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintSQIndex4PreloadThumbnailImage = 0
        mintImgIndex4PreloadThumbnailImage = 0

        if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
    } // end of PreloadThumbnailImageProcessBegin

    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 4. 將 圖片高度 正確計算之後，回寫進去 ContentHtml，再 顯示畫面
        marrContentData.forEach((ContentData) => {
            // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)

            console.log("ContentData: ", ContentData)
        }) // end of forEach marrContentData

        console.log("PreloadImageProcessEnd END marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    } // end of PreloadThumbnailImageProcessEnd

    /*===========================================
    summary: 讀取 縮圖 題目圖片
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function LoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(SQIndex, ImgIndex, this.width, this.height)
        }; // end of image onload
        // objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].Url
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].ThumbnailImageUrl
    } // end of LoadThumbnailImage

    /*===========================================
    summary: 讀取 縮圖 題目圖片完成 事件
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function ThumbnailImageLoadedHandler(SQIndex, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", SQIndex, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[SQIndex].ImageList[ImgIndex].Width = Width
            marrContentData[SQIndex].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[SQIndex].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler END DisplayHeight: ", parseInt(marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight))

            GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler ContentData null")
        }
    } // end of ThumbnailImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 縮圖
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadThumbnailImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadThumbnailImage++
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadThumbnailImage++
            mintImgIndex4PreloadThumbnailImage = 0

            if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
            else
            {
                GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    } // end of GotoNextLoadThumbnailImage

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")

        mintSQIndex4PreloadOriginalImage = 0
        mintImgIndex4PreloadOriginalImage = 0

        if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
    } // end of PreloadOriginalImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")
    } // end of PreloadOriginalImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 題目圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(SQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalImage

    /*===========================================
    summary: 讀取 原圖 題目圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalImageLoadedHandler(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", SQIndex, ImgIndex)

        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[SQIndex].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[SQIndex].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)
            marrDisplayQuestion[SQIndex].ContentText = marrContentData[SQIndex].ContentText
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalImageLoadedHandler ContentData null")
        }
    } // end of OriginalImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadOriginalImage++
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadOriginalImage++
            mintImgIndex4PreloadOriginalImage = 0

            if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
            else
            {
                GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalImage
    // #endregion PreloadImage

    /*===========================================
    summary: 初始化 填空題 顯示資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function FormatFQQuestionData(LUInfo, TestSheet)
    {
        console.log(COMP_NAME + ".FormatFQQuestionData: ", LUInfo, TestSheet)

        let arrSuperQuestion = LUInfo.SuperQuestion
        let arrDisplayQuestion = []
        let objDisplayQuestion = null
        let objFillInQ = null

        let intSQIndex = 0
        let intSQCount = arrSuperQuestion.length
        let intFQIndex = 0
        let intFQCount = 0
        let arrAnswer = TestSheet.AnswerList
        let objAnswer = null

        let arrFillInQ = []

        let strFQAnswer = ""
        let arrFQAnswer = []
        let arrFQSubAnswer = []

        let objContent = null
        let strQuestionTextCN = ""

        console.log(COMP_NAME + ".FormatFQQuestionData marrContentData: ", marrContentData)

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            // 處理 顯示的 Content
            objContent = marrContentData[intSQIndex]
            console.log(COMP_NAME + ".FormatFQQuestionData objContent: ", objContent)

            objDisplayQuestion = {
                "SQSeqNo": arrSuperQuestion[intSQIndex].SQSeqNo,
                "ContentText": objContent.ContentText,
                "FillInQ": []
            }

            intFQIndex = 0
            intFQCount = arrSuperQuestion[intSQIndex].FillInQ.length
            arrFillInQ = arrSuperQuestion[intSQIndex].FillInQ
            arrFQSubAnswer = []

            for (intFQIndex = 0; intFQIndex < intFQCount; intFQIndex++)
            {
                strFQAnswer = ""
                
                objFillInQ = {
                    "FQSeqNo": arrFillInQ[intFQIndex].FQSeqNo,
                    "QuestionText": arrFillInQ[intFQIndex].Q,
                    "QuestionTextCN": "",
                    "AnswerText": "",
                    "FQAnswer": "",
                    "AnswerID": 0,
                    "TeacherFeedbackText": ""
                }

                let intSQSeqNo = parseInt(arrSuperQuestion[intSQIndex].SQSeqNo)
                let intFQSeqNo = parseInt(arrFillInQ[intFQIndex].FQSeqNo)

                // 找出 顯示 題目文字
                if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    strQuestionTextCN = arrFillInQ[intFQIndex].MajorQ
                    objFillInQ.AnswerText = arrFillInQ[intFQIndex].MajorA
                }
                else
                {
                    strQuestionTextCN = arrFillInQ[intFQIndex].MinorQ
                    objFillInQ.AnswerText = arrFillInQ[intFQIndex].MinorA
                }

                if (
                    (typeof(strQuestionTextCN) !== 'undefined') &&
                    (strQuestionTextCN !== null) &&
                    (strQuestionTextCN !== "")
                    )
                {
                    objFillInQ.QuestionText = strQuestionTextCN
                }

                // 找出 使用者 選擇的答案
                objAnswer = arrAnswer.find(AnswerData => 
                    (
                        (parseInt(AnswerData.SQSeqNo) === intSQSeqNo) &&
                        (parseInt(AnswerData.FQSeqNo) === intFQSeqNo)
                    )
                )
                
                if (
                    (typeof(objAnswer) !== 'undefined') &&
                    (objAnswer !== null)
                    )
                {
                    objFillInQ.AnswerID = objAnswer.AnswerID
                    objFillInQ.FQAnswer = objAnswer.FQAnswer

                    if (
                        (typeof(objAnswer.FQAnswer) !== 'undefined') &&
                        (objAnswer.FQAnswer !== null) &&
                        (objAnswer.FQAnswer !== "")
                        )
                    {
                        strFQAnswer = objAnswer.FQAnswer
                    }

                    if (
                        (typeof(objAnswer.TeacherFeedbackText) !== 'undefined') &&
                        (objAnswer.TeacherFeedbackText !== null) &&
                        (objAnswer.TeacherFeedbackText !== "")
                        )
                    {
                        objFillInQ.TeacherFeedbackText = objAnswer.TeacherFeedbackText
                    } // end of if (objAnswer.TeacherFeedbackText !== null)
                } // end of if (objAnswer !== null)
                arrFQSubAnswer.push(strFQAnswer)
                // console.log(COMP_NAME + ".FormatFQQuestionData strFQAnswer: ", strFQAnswer)
                // console.log(COMP_NAME + ".FormatFQQuestionData arrFQSubAnswer: ", arrFQSubAnswer)

                objDisplayQuestion.FillInQ.push(objFillInQ)
            } // end of for (intFQIndex = 0;

            arrFQAnswer.push(arrFQSubAnswer)
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSQIndex = 0;

        setAnswerArray(arrFQAnswer)
        console.log(COMP_NAME + ".FormatFQQuestionData arrFQAnswer: ", arrFQAnswer)

        console.log(COMP_NAME + ".FormatFQQuestionData END arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatFQQuestionData

    /*===========================================
    summary: Submit後 更新 Cache資料
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function UpdateCacheSinceSubmit(DataFromSubmit)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: ", DataFromSubmit)

        let objTestTime = new Date()

        let objNewAssign = {
            "AnswerList": DataFromSubmit.AnswerList,
            "AssignID": DataFromSubmit.AssignID,
            "Score": DataFromSubmit.Score,
            "TestedTime": objTestTime.ToBCUTCString()
        }

        // 更新 History 資料
        console.log("objNewAssign: ", objNewAssign)
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.unshift(objNewAssign)

        // 清除 Temp 資料
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList = []
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime = null


        let objCallbackData = {
            "Action": "UpdateCacheSinceSubmit"
        }
        props.CallbackRef(objCallbackData)

        setUpdateDataTime(new Date().getTime())
    } // end of UpdateCacheSinceSubmit

    /*===========================================
    summary: SaveTemp後 更新 Cache資料 
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function UpdateCacheSinceSaveTemp(DataFromSaveTemp)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSaveTemp: ", DataFromSaveTemp)

        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = DataFromSaveTemp
    } // end of UpdateCacheSinceSaveTemp
    // #endregion Other Functions

    // #region Get ClassName and Style
    /*===========================================
    summary: 取得 送出作答資料按鈕 Cls
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function GetSubmitButtonCls(TestSheet, PropsIsBlockedInstructor)
    {
        let objCls = cssFillInContent.btnScoreToolMainDisable

        if (
            (!PropsIsBlockedInstructor) &&
                (
                    (TestSheet.Mode === TestSheetModeEnum.Temp) ||
                    (TestSheet.Dirty)
                )
            )
        {
            objCls = cssFillInContent.btnScoreToolMain
        }

        return objCls
    } // end of GetSubmitButtonCls

    /*===========================================
    summary: 取得 歷史紀錄按鈕 Cls
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function GetHistoryButtonMainCls(TempAnsData, HistoryData)
    {
        let objCls = cssFillInContent.btnScoreToolMainDisable
        if (
            (
                (typeof (TempAnsData) !== "undefined") &&
                (TempAnsData !== null) &&
                (typeof (TempAnsData.TestedTime) !== "undefined") &&
                (TempAnsData.TestedTime !== null)
            ) // 有 部分完成的答案
            ||
            (
                (typeof (HistoryData) !== "undefined") &&
                (HistoryData !== null) &&
                (typeof (HistoryData.NewAssignList) !== "undefined") &&
                (HistoryData.NewAssignList !== null) &&
                (HistoryData.NewAssignList.length > 0)
            ) // 有 答題完成的歷史答案
        )
        {
            objCls = cssFillInContent.btnScoreToolMain
        }
        return objCls
    } // end of GetHistoryButtonMainCls

    /*===========================================
    summary: 取得 暫存作答資料按鈕 Cls
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function GetSaveButtonMainCls(TestSheetDirty)
    {
        let objCls = cssFillInContent.btnScoreToolMainDisable

        if (TestSheetDirty)
        {
            objCls = cssFillInContent.btnScoreToolMain
        }

        return objCls
    } // end of GetSaveButtonMainCls

    /*===========================================
    summary: 取得 再做一次 按鈕 Cls
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function GetRetryButtonCls(PropsIsBlockedInstructor)
    {
        let objCls = cssFillInContent.btnScoreToolMain

        if (PropsIsBlockedInstructor)
        {
            objCls = cssFillInContent.btnScoreToolMainDisable
        }

        return objCls
    } // end of GetRetryButtonCls
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    /*===========================================
    summary: 上傳 考卷答案 資料 後續處理
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSubmit(ReturnData)

        mobjCallParam = null
        mintIndex4HistoryItemToShow = 0

        SetTestSheetObject(TestSheetModeEnum.History)
        marrDisplayQuestion = FormatFQQuestionData(props.LUInfo, mobjTestSheet)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of UploadNewAssignmentResultAfterProcess

    /*===========================================
    summary: 上傳 考卷暫存答案 資料 後續處理
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentTmpResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSaveTemp(ReturnData)

        mobjCallParam = null
        
        SetTestSheetObject(TestSheetModeEnum.Temp)
        marrDisplayQuestion = FormatFQQuestionData(props.LUInfo, mobjTestSheet)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultAfterProcess marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of UploadNewAssignmentTmpResultAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 上傳 考卷暫存答案 資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentTmpResult()
    {
        // console.log(COMP_NAME + ".UploadNewAssignmentTmpResult: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResult BEGIN")
        let objRetryFuncRef = UploadNewAssignmentTmpResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentTmpResult_Title, window.gAppUI.ERR_UploadAssignmentTmpResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentTmpResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentTmpResult)

            let objCallData = {
                "Func": "UploadNewAssignmentTmpResult",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "ClassID": mobjCallParam.ClassID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "Answer": JSON.stringify(mobjCallParam.AnswerList),
                "Score": mobjCallParam.Score,
                "ActionType": mobjCallParam.ActionType
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UploadNewAssignmentTmpResult

    /*===========================================
    summary: 上傳 考卷暫存答案 資料 Callback
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentTmpResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentTmpResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentTmpResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentTmpResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentTmpResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentTmpResultCallback Return.Data", Return.Data)

            UploadNewAssignmentTmpResultAfterProcess(Return.Data)
        }
    } // end of UploadNewAssignmentTmpResultCallback

    /*===========================================
    summary: 上傳 考卷答案 資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentResult()
    {
        // console.log(COMP_NAME + ".UploadNewAssignmentResult: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UploadNewAssignmentResult BEGIN")
        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentResult_Title, window.gAppUI.ERR_UploadAssignmentResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)

            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "ClassID": mobjCallParam.ClassID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "Answer": JSON.stringify(mobjCallParam.AnswerList)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UploadNewAssignmentResult

    /*===========================================
    summary: 上傳 考卷答案 資料 Callback
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function UploadNewAssignmentResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data)

            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    } // end of UploadNewAssignmentResultCallback
    // #endregion Web Service

    // #region Component            
    /*===========================================
    summary: Submit or Start 按鈕 顯示Component  
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function ComponentSubmitOrStartButton( {TestSheet, PropsIsBlockedInstructor} )
    {  
        let objButtonBlock = null
        if (TestSheet.Mode === TestSheetModeEnum.History)
        {
            // Start
            objButtonBlock =    <div className={GetRetryButtonCls(PropsIsBlockedInstructor)} onClick={() => TryAgainOnTapHandler()}>
                                    <div className={cssFillInContent.divTryAgainIcon}/>
                                    <div className={cssFillInContent.divScoreToolButtonText}>
                                        {PackageVariablesLibs.UISettings.BTN_Retry}
                                    </div>
                                </div>
        }
        else if (
            (TestSheet.Mode === TestSheetModeEnum.New) ||
            (TestSheet.Mode === TestSheetModeEnum.Temp)
            )
        {
            objButtonBlock =    <div className={GetSubmitButtonCls(TestSheet, PropsIsBlockedInstructor)} onClick={() => SubmitOnTapHandler()}>
                                    <div className={cssFillInContent.divSubmitIcon}/>
                                    <div className={cssFillInContent.divScoreToolButtonText}>
                                        {window.gAppUI.BTN_Submit}
                                    </div>
                                </div>
        }

        return(
            <>
                <div className={cssFillInContent.divScoreToolBar}/>

                {objButtonBlock}
            </>
        )
    } // end of ComponentSubmitOrStartButton

    /*===========================================
    summary: Save 按鈕 顯示Component  
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function ComponentSaveButton( {TestSheet} )
    {  
        if (
            (TestSheet.Mode === TestSheetModeEnum.New) ||
            (TestSheet.Mode === TestSheetModeEnum.Temp)
            )
        {
            return(
                <>
                    <div className={cssFillInContent.divScoreToolBar}/>

                    <div className={GetSaveButtonMainCls(TestSheet.Dirty)} onClick={() => SaveOnTapHandler()}>
                        <div className={cssFillInContent.divSaveIcon}/>
                        <div className={cssFillInContent.divScoreToolButtonText}>
                            {window.gAppUI.BTN_Save}
                        </div>
                    </div>
                </>
            )
        }
        else
        {
            // (TestSheetMode === TestSheetModeEnum.History) 
            return ""
        }
    } // end of ComponentSaveButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function ComponentHistoryButton( {TempAnsData, HistoryData} )
    {  
        return(
            <>
                <div className={cssFillInContent.divScoreToolBar}/>
                
                <div className={GetHistoryButtonMainCls(TempAnsData, HistoryData)} 
                        onClick={() => HistoryOnTapHandler()}>
                    <div className={cssFillInContent.divHistoryIcon}/>
                    <div className={cssFillInContent.divScoreToolButtonText}>
                        {window.gAppUI.BTN_History}
                    </div>
                </div>
            </>
        )
    } // end of ComponentHistoryButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function ComponentScoreArea( {TestSheetScore} )
    {  
        let strScore = window.gAppUI.LBL_NotScore
        if (
            (typeof(TestSheetScore) !== 'undefined') &&
            (TestSheetScore !== null) &&
            (parseInt(TestSheetScore) >= 0)
            )
        {
            strScore = TestSheetScore
        }

        return(
            <>
                <div className={cssFillInContent.divScoreToolTitle}>
                    {window.gAppUI.LBL_YourScore}:
                </div>
                <div className={cssFillInContent.divScoreToolScore}>
                    {strScore}
                </div>
            </>
        )
    } // end of ComponentScoreArea
    
    /*===========================================
    summary: FillInQNo 顯示Component  
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function ComponentFillInQNo( {FillInQIndex} )
    {   
        let strNo = (FillInQIndex + 1).toString() + "."
        return(
            <div className={cssFillInContent.divFillInQNo}>
                {strNo}
            </div>
        )
    } // end of ComponentFillInQNo
    // #endregion Component

    // #region Render
    /*===========================================
    summary: Render Teacher Feedback 打分數模式 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderTeacherFeedbackResultWrapper(FillInQData, TestSheetScore)
    {
        if (
            (typeof(TestSheetScore) !== 'undefined') &&
            (TestSheetScore !== null) &&
            (parseInt(TestSheetScore) >= 0)
            )
        {
            return (
                <div className={cssFillInContent.divSuggestedTeacherFeedbackMain}>
                    <div className={cssFillInContent.divSuggestedTeacherFeedbackTitle}>
                        {window.gAppUI.LBL_TeachersComments}:
                    </div>

                    <div className={cssFillInContent.divFeedback4Result}>
                        {FillInQData.TeacherFeedbackText}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderTeacherFeedbackResultWrapper

    /*===========================================
    summary: 正確答案區域 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 修整
    ===========================================*/
    function RenderSuggestedAnswerAreaWrapper(AnswerText, TestSheetMode)
    {   
        if (
            (TestSheetMode === TestSheetModeEnum.New) ||
            (TestSheetMode === TestSheetModeEnum.Temp) ||
                (
                    (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&
                    
                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 作答模式 不顯示正確答案
            // 老師設定 不顯示正確答案
        }
        else
        {
            return(
                <>
                    <div className={cssFillInContent.divSuggestedAnswerTitle}>
                        {window.gAppUI.LBL_SuggestedAnswer}
                    </div>

                    <div className={cssFillInContent.divSuggestedAnswerText}>
                        {AnswerText}
                    </div>
                </>
            )
        }
    } // end of RenderSuggestedAnswerAreaWrapper

    /*===========================================
    summary: 學生作答區域 顯示 
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderStudentAnswerAreaWrapper(QuestionIndex
            , FillInQData, FillInQIndex, StateAnswerArray, TestSheetMode
            , PropsIsBlockedInstructor)
    {   
        let objAnswer = null
        if (
            (PropsIsBlockedInstructor) ||
            (TestSheetMode === TestSheetModeEnum.History)
            )
        {
            objAnswer = <div className={cssFillInContent.divAnswerText}>
                            {FillInQData.FQAnswer}
                        </div>
        }
        else if (
            (TestSheetMode === TestSheetModeEnum.Temp) ||
            (TestSheetMode === TestSheetModeEnum.New)
            )
        {
            objAnswer = <>
                            <label htmlFor="txtAnswer" className={cssFillInContent.divHidden}>
                                {window.gAppUI.LBL_AnswerPlaceHolder}
                            </label>
                            <input id="txtAnswer" type="text"
                                className={cssFillInContent.txtInput}
                                value={StateAnswerArray[QuestionIndex][FillInQIndex]}
                                onChange={(event) => AnswerTextOnChangeHandler(event, StateAnswerArray, QuestionIndex, FillInQIndex)}
                                maxLength={MAX_ANSWER_CHARACHERS}
                                />
                        </>
        }

        return(
            <>
                <div className={cssFillInContent.divQuestionText}>
                    {FillInQData.QuestionText}
                </div>

                {objAnswer}
            </>
        )
    } // end of RenderStudentAnswerAreaWrapper
    
    /*===========================================
    summary: Render Question Sub Unit 的顯示
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderQuestionSubUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)
    {
        return (
            <div className={cssFillInContent.divQuestionSubUnit}>
                {RenderStudentAnswerAreaWrapper(QuestionIndex, FillInQData, FillInQIndex, answerArray, mobjTestSheet.Mode, props.IsBlockedInstructor)}
                
                {RenderSuggestedAnswerAreaWrapper(FillInQData.AnswerText, mobjTestSheet.Mode)}

                {RenderTeacherFeedbackResultWrapper(FillInQData, mobjTestSheet.Score)}
            </div>
        )
    } // end of RenderQuestionSubUnitWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)
    {
        return (
            <>
                <ComponentFillInQNo FillInQIndex={FillInQIndex}/>

                {RenderQuestionSubUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)}
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Question Title Area 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderQuestionTitleAreaWrapper(QuestionData)
    {
        return (
            <div className={cssFillInContent.divQuestionTitleArea}>
                <div className={cssFillInContent.divContentText}>
                    {parse(QuestionData.ContentText)}
                </div>
            </div>
        )
    } // end of RenderQuestionTitleAreaWrapper

    /*===========================================
    summary: Render QuestionArea 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderQuestionAreaWrapper()
    {
        return (
            <div ref={mrefScrollArea} className={cssFillInContent.divQuestionArea}>
                {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                    <div key={QuestionIndex} className={cssFillInContent.divQuestionUnitMain}>
                        {RenderQuestionTitleAreaWrapper(QuestionData)}

                        {QuestionData.FillInQ.map((FillInQData, FillInQIndex) =>
                            <div key={FillInQIndex}  className={cssFillInContent.divQuestionUnitArea}>
                                {RenderQuestionUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAreaWrapper

    /*===========================================
    summary: Render ScoreToolArea 的顯示
    remarks: 000 Tim 2022/01/04 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderScoreToolAreaWrapper()
    {
        return (
            <div className={cssFillInContent.divScoreToolArea}>
                <ComponentScoreArea TestSheetScore={mobjTestSheet.Score} />

                <ComponentHistoryButton TempAnsData={mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]} 
                    HistoryData={mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]} />

                <ComponentSaveButton TestSheet={mobjTestSheet} />

                <ComponentSubmitOrStartButton TestSheet={mobjTestSheet} PropsIsBlockedInstructor={props.IsBlockedInstructor}/>
            </div>
        )
    } // end of RenderScoreToolAreaWrapper

    /*===========================================
    summary: Render SubSub 標題區域 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderSubSubTitleAreaWrapper()
    {
        return (
            <div className={cssFillInContent.divSubSubTitleArea}>
                <div className={cssFillInContent.divSubSubTitle}>
                    {mobjDisplaySubSubSection.NameEN}
                </div>

                <div className={cssFillInContent.divSubSubDividerBar}/>
                
                <div className={cssFillInContent.divSubSubTitle}>
                    {mobjDisplaySubSubSection.NameCN}
                </div>
            </div>
        )
    } // end of RenderSubSubTitleAreaWrapper

    /*===========================================
    summary: Render SubSubToolArea 的顯示
    remarks: 000 Tim 2022/01/04 Create
    ===========================================*/
    function RenderSubSubToolAreaWrapper()
    {
        return (
            <div className={cssFillInContent.divSubSubToolArea}>
                {RenderSubSubTitleAreaWrapper()}
                {RenderScoreToolAreaWrapper()}
            </div>
        )
    } // end of RenderSubSubToolAreaWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssFillInContent.divContent}>
                    {RenderSubSubToolAreaWrapper()}
                    
                    {RenderQuestionAreaWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssFillInContent.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper
    
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default FillInContent